import type { SuccessfulLogin } from '@playq/octopus2-auth';
import { PublicMFAConfigHelpers, UserRole } from '@playq/octopus2-auth';

import { history } from '/Router/history';
import { createStorage, sessionStorageMethods } from '/storage';
import { PersistedQueryKeys } from '/common/models';
import { snackbarService } from '/common/snackbarService';
import { unsetSentryUser } from '/common/Sentry';
import { clearCache, resetAuthorization, setAuthorization } from '/api/core';
import { permsService } from '/api/domains';

import { createAppAsyncThunk } from '../../hooks';

import { stopTokenRefresher } from './tokenTimer';

const storage = createStorage({ prefix: PersistedQueryKeys.StoragePrefix, storage: sessionStorageMethods });

export const fetchCompanyPerms = createAppAsyncThunk('auth/fetchCompanyPerms', async () => {
  try {
    const perms = await permsService.getPermsByCompany();
    return perms.serialize();
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : String(e);
    snackbarService.error(`GetPermsByCompany: ${message}`);
    console.error('auth.getPermsByCompany', e);
    throw e;
  }
});
export const login = createAppAsyncThunk('auth/login', (res: SuccessfulLogin, api) => {
  setAuthorization(res.tokens.access);

  const mfa = res.user.mfa ? PublicMFAConfigHelpers.serialize(res.user.mfa) : undefined;

  const { role } = res.user;
  const isUserAdmin = role === UserRole.Admin || role === UserRole.SuperAdmin;

  if (!isUserAdmin) {
    api.dispatch(fetchCompanyPerms());
  }
  return {
    ...res.serialize(),
    mfa,
  };
});

export const logout = createAppAsyncThunk('auth/logout', (_action) => {
  stopTokenRefresher();
  unsetSentryUser();
  const loginRedirectURL = window.location.pathname;
  storage.flush();
  history.push('/login');
  clearCache();
  resetAuthorization();
  return {
    loginRedirectURL,
  };
});
